import React from 'react'
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer'
import TopNav from '../../../components/TopNav/TopNav'

const PrivacyPolicy = () => {
  return (
    <StyledBgContainer>
      <TopNav showArrow={true} />
      <h1>Privacy Policy</h1>
      <p>
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry.
      </p>
      <p>
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industrys standard dummy text ever
        since the 1500s, when an unknown printer took a galley of type and
        scrambled it to make a type specimen book, but also the leap into
        electronic typesetting, remaining essentially unchanged. It was
        popularised in the 1960s with the release of Letraset sheets containing
        Lorem Ipsum passages, and more recently with desktop publishing software
        like Aldus PageMaker including versions of Lorem Ipsum. Why do we use
        it? It is fact that a reader will be distracted by the readable content
        of a page when looking at its layout. making it look like readable
        English. Many desktop publishing packages and web page editors now use
        Lorem Ipsum as their default model text, and a search for lorem ipsum
        will uncover many web sites still in their infancy. Various versions
        have evolved over the years, sometimes by accident, sometimes on purpose
        (injected humour and the like). Why do we use it? It is a long
        established fact that a reader will be distracted by the readable
        content of a page when looking at its layout. The point of using Lorem
        Ipsum is more-or-less , as opposed to using Content here, content
        hereVarious versions have evolved over the years, sometimes by accident,
        sometimes on purpose (injected humour and the like).
      </p>
    </StyledBgContainer>
  )
}

export default PrivacyPolicy
